import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { QIcon_outlink } from '@repo/icons/index'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
import { useBasicPopup } from '../../../components/basic/popup/BasicPopup'
import { useConfirmPopup } from '../../../components/basic/popup/ConfirmPopup'

import { DSRadio, useToast } from '@repo/design-system/index'
import { differenceInSeconds } from 'date-fns'
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'
import LoadingSpinner from '../../../components/common/LoadingSpinner'
import { useEventTracking } from '../../../helpers/gtmHelper'
import apis from '../../../modules/apis'
import { useCustomerType } from '../../../modules/apis/student/products'
import { axiosGet, axiosPost } from '../../../modules/axiosHelper'
import { useLocale } from '../../../modules/context/LocaleContext'
import { useCurrentUser } from '../../../modules/context/UserContext'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useIsAdminLogin from '../../../modules/hooks/common/useIsAdminLogin'
import useIsWebview from '../../../modules/hooks/common/useIsWebview'
import { LOCALE_EN, LOCALE_KO } from '../../../modules/i18n/config'
import {
  n_common,
  n_lesson_review,
  n_upcoming_lessons,
  s_common,
  s_lesson_style,
  s_upcoming_lessons,
} from '../../../modules/i18n/strings/auto/wording'
import { n_system } from '../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../modules/i18n/useTranslation'
import { track } from '../../../modules/track'
import urls from '../../../modules/urls'
import { locationMove, locationMoveLocaleNewTab } from '../../../modules/utils'
import { LOCATION, LOG_CATEGORY, LOG_TYPE } from '../../../modules/vars'
import { CheckBoxs } from '../../_legacy/CheckBoxs'
import { CardTextarea } from '../materials/QuestionSelect/AnswerItem'

export const lessonRadioGroup1 = ({ t, readOnly = false }) => {
  return {
    radioGroup: {
      name: 'option',
      items: [
        {
          name: (
            <>
              <div className="text-[14px]">{t(n_upcoming_lessons.lesson_style.mode_correction_instant)}</div>
              <div className="text-[12px] text-gray-500">
                {t(n_upcoming_lessons.lesson_style.mode_correction_instant_info)}
              </div>
            </>
          ),
          value: 0,
          disabled: readOnly,
        },
        {
          name: (
            <>
              <div className="text-[14px]">{t(n_upcoming_lessons.lesson_style.mode_correction_intermittent)}</div>
              <div className="text-[12px] text-gray-500">
                {t(n_upcoming_lessons.lesson_style.mode_correction_intermittent_info)}
              </div>
            </>
          ),
          value: 1,
          disabled: readOnly,
        },
      ],
    },
  }
}
export const lessonRadioGroup2 = ({ t, readOnly = false }) => {
  return {
    radioGroup: {
      name: 'option',
      items: [
        {
          name: (
            <>
              <div className="text-[14px]">{t(n_upcoming_lessons.lesson_style.mode_discussion_mode55)}</div>
              <div className="text-[12px] text-gray-500">
                {t(n_upcoming_lessons.lesson_style.mode_discussion_mode55_info)}
              </div>
            </>
          ),
          value: 0,
          disabled: readOnly,
        },
        {
          name: (
            <>
              <div className="text-[14px]">{t(n_upcoming_lessons.lesson_style.mode_discussion_mode82)}</div>
              <div className="text-[12px] text-gray-500">
                {t(n_upcoming_lessons.lesson_style.mode_discussion_mode82_info)}
              </div>
            </>
          ),
          value: 1,
          disabled: readOnly,
        },
      ],
    },
  }
}

/**
 *
 * @param fixedToNo : true 일 경우, toggle을 눌러도 체크가 안되게 함 & 특정 조건일 때 No로 고정
 *
 */
const ButtonToggleTab = (props: { leftLabel; rightLabel; defaultChecked; handleClick; bottomFlat?; fixedToNo? }) => {
  const { leftLabel, rightLabel, defaultChecked, handleClick, bottomFlat = false, fixedToNo = false } = props
  const [checked, setChecked] = useState(fixedToNo ? false : defaultChecked)
  return (
    <div
      className={classNames(
        [fixedToNo && 'cursor-not-allowed grayscale filter'],
        'flex w-full space-x-[8px] py-[12px]'
      )}
    >
      <div
        className={classNames(
          [
            checked ? 'border-purple-500 bg-purple-50 text-purple-500' : 'border-gray-300 bg-white text-black',
            !fixedToNo ? 'cursor-pointer' : '',
          ],
          'textCenter flex w-1/2 justify-center border-[1.5px] px-[12px] py-[8px]'
        )}
        style={{ borderRadius: '5px' }}
        onClick={() => {
          if (fixedToNo) return
          setChecked(true)
          handleClick(true)
        }}
      >
        <span
          className={classNames({ 'text-purple-500': checked }, { 'text-black': !checked }, 'text-[14px] font-bold')}
        >
          {leftLabel}
        </span>
      </div>
      <div
        className={classNames(
          [
            !checked ? 'border-purple-500 bg-purple-50 text-purple-500' : 'border-gray-300 bg-white text-black',
            !fixedToNo ? 'cursor-pointer' : '',
          ],
          'textCenter flex w-1/2 justify-center border-[1.5px] px-[12px] py-[8px]'
        )}
        style={{ borderRadius: '5px' }}
        onClick={() => {
          if (fixedToNo) return
          setChecked(false)
          handleClick(false)
        }}
      >
        <span
          className={classNames({ 'text-purple-500': !checked }, { 'text-black': checked }, 'text-[14px] font-bold')}
        >
          {rightLabel}
        </span>
      </div>
    </div>
  )
}

type LessonStylePopupBodyPropsType = {
  item: any
  lessonId?: any
  currentUser: any
  isConfirmModalOpen: boolean
  isWriting?: boolean
  handleCancelLessonStyleWebview?: any
  handleSubmitLessonStyleWebview?: any
  setShowPopup?: any
}

const LessonStylePopupBody = ({
  item,
  lessonId,
  currentUser,
  isConfirmModalOpen,
  isWriting,
  handleCancelLessonStyleWebview,
  handleSubmitLessonStyleWebview,
  setShowPopup,
}: LessonStylePopupBodyPropsType) => {
  const introRef = useRef<HTMLTextAreaElement>(null)
  const { sendPageViewEvent } = useEventTracking()
  const confirmPopup = useConfirmPopup()
  const basicPopup = useBasicPopup()
  const { t, locale, isLocaleKO } = useTranslation()
  const { toastSuccess } = useToast()
  const [disabled, setDisabled] = useState(true)
  const [allowRecord, setAllowRecord] = useState(item.allow_record != null ? item.allow_record : false)
  const [allowCAF, setAllowCAF] = useState(item.allow_caf != null ? item.allow_caf : false)
  const [skipIntro, setSkipIntro] = useState(item.intro.skip_intro_user != null ? item.intro.skip_intro_user : true)
  const [lessonMode, setLessonMode] = useState(item.lesson_mode.mode != null ? item.lesson_mode.mode : 0)
  const [lessonOption, setLessonOption] = useState(item.lesson_mode.option != null ? item.lesson_mode.option : 0)
  const [selectedRequest, setSelectRequest] = useState(item.selectable_requests)
  const [intensiveArea, setIntensiveArea] = useState(item.intensive_area)
  const [timezone, setTimezone] = useState(currentUser?.timezone ? currentUser?.timezone : 'Asia/Seoul')
  const isWebview = useIsWebview()
  const router = useAppRouter()

  const [intro, setIntro] = useState(item.intro.desc ? item.intro.desc : '')
  const [otherRequest, setOtherRequest] = useState(item.other_request ? item.other_request : '')

  const startTime = item.lesson.start_time
  const utcDate = zonedTimeToUtc(startTime, timezone)
  const lessonStartTime = utcToZonedTime(utcDate, timezone)
  const currentTime = utcToZonedTime(new Date(), timezone)
  let isBeforeFifteen = false
  if (differenceInSeconds(lessonStartTime, currentTime) > 900) {
    // 900초 = 15분
    isBeforeFifteen = true
  }
  const CAFChoose = () => {
    const { locale } = useLocale()
    const { t } = useTranslation()

    /**
     * 녹음 설정 OFF && !isWriting : 녹음 설정 on 필요 안내 문구
     * isWriting : 라이팅 수업 caf 미지원 안내 문구
     */
    const showCAFRecordNotice = !allowRecord && !isWriting
    const showCAFWritingMaterialNotice = isWriting

    const handleOnclick = (tf) => {
      if (!allowRecord) return
      setDisabled(false)
      setAllowCAF(tf)
    }
    const onClickWhatIsCAF = () => {
      if (isWebview) {
        if (isLocaleKO) {
          router.push('', {
            appScreenName: APP_SCREEN_NAME.OUTLINK_SCREEN,
            appSendData: {
              url: 'https://www.ringleplus.com/ko/student/landing/blog/ai-analysis-about',
            },
          })
        } else {
          router.push('', {
            appScreenName: APP_SCREEN_NAME.OUTLINK_SCREEN,
            appSendData: {
              url: 'https://www.ringleplus.com/en/student/landing/blog/ai-analysis-about-eng',
            },
          })
        }
      } else {
        const cafLink = t([
          '/student/landing/blog/ai-analysis-about',
          '/student/landing/blog/ai-analysis-about-eng',
          '',
          '/student/landing/blog/english-related-17',
          '/student/landing/blog/english-related-13',
          '/student/landing/blog/ai-analysis-about-eng',
          '',
        ])
        locationMoveLocaleNewTab(cafLink)
      }
    }
    return (
      <div className="mb-[32px]">
        <div className="mb-[8px] mt-[16px] flex items-center justify-between">
          <div className="text-[16px] font-medium">{t(n_upcoming_lessons.lesson_style.analysis_title)}</div>
          {(locale == LOCALE_KO || locale == LOCALE_EN) && (
            <div className="flex items-center justify-end gap-[4px] hover:cursor-pointer" onClick={onClickWhatIsCAF}>
              <QIcon_outlink width={15} height={15} />
              <div className="text-gray-600">{t(n_system.lesson_style_caf)}</div>
            </div>
          )}
        </div>
        {!item.trial && (
          <ButtonToggleTab
            defaultChecked={allowCAF}
            leftLabel={t(n_upcoming_lessons.lesson_style.analysis_yes)}
            rightLabel={t(n_upcoming_lessons.lesson_style.analysis_no)}
            handleClick={handleOnclick}
            fixedToNo={allowRecord !== true || isWriting}
          />
        )}
        <div className="Body2-14Md text-gray-500 mt-[8px]"> {t(n_upcoming_lessons.lesson_style.mode_info2)}</div>
        {showCAFRecordNotice && (
          <div className="mt-[8px]">
            <span className="text-[14px] font-medium text-gray-500">
              {t(n_upcoming_lessons.lesson_style.intro_info)}
            </span>
          </div>
        )}
        {showCAFWritingMaterialNotice && (
          <div className="mt-[8px]">
            <span className="text-[14px] font-medium text-gray-500">{t(n_lesson_review.ai_status_title4)}</span>
          </div>
        )}
      </div>
    )
  }

  const RecordChoose = ({ item }) => {
    const { t } = useTranslation()
    const { data: customerType } = useCustomerType()
    const handleOnclick = (tf) => {
      setDisabled(false)
      setAllowRecord(tf)
      if (allowRecord !== true) setAllowCAF(false)
    }
    return (
      <div>
        <div className="mb-[8px] mt-[16px] text-[16px] font-medium">
          {t(n_upcoming_lessons.lesson_style.record_title)}
        </div>
        {/* 체험수업 아닐시 */}
        {isBeforeFifteen && !customerType?.isMulticampus && !item.trial && (
          <ButtonToggleTab
            defaultChecked={allowRecord}
            leftLabel={t(n_upcoming_lessons.lesson_style.record_yes)}
            rightLabel={t(n_upcoming_lessons.lesson_style.record_no)}
            handleClick={handleOnclick}
          />
        )}
        <div className="mb-[32px] mt-[8px] text-[12px] font-normal text-gray-500">
          {/* *수업 녹음 MP3파일은 수업 종료 후 파일 제작이 완료되면 “복습" 메뉴에서 확인하실 수 있습니다. */}
          {isBeforeFifteen && !customerType?.isMulticampus && (
            <li className="Body2-14Md">
              {t(n_upcoming_lessons.lesson_style.record_info1)}
              <br />
            </li>
          )}
          {item.trial && (
            <li className="Body2-14Md">
              {t(n_upcoming_lessons.lesson_style.record_info3)}
              <br />
            </li>
          )}
          {!item.trial && <li className="Body2-14Md">{t(n_upcoming_lessons.lesson_style.record_info2)}</li>}
        </div>
      </div>
    )
  }

  // 수업모드 new radio button
  const OptionChoose = ({ item }) => {
    const { t } = useTranslation()
    const handleTabClick = (tf) => {
      setDisabled(false)
      setLessonMode(tf ? 0 : 1)
    }
    const handleOnclick = (val) => {
      setDisabled(false)
      setLessonOption(val)
    }

    return (
      <div>
        <div className="mb-[8px] text-[16px] font-medium">{t(n_upcoming_lessons.lesson_style.mode_title)}</div>
        <ButtonToggleTab
          defaultChecked={lessonMode == 0 ? true : false}
          leftLabel={t(n_upcoming_lessons.lesson_style.mode_correction)}
          rightLabel={t(n_upcoming_lessons.lesson_style.mode_discussion)}
          handleClick={handleTabClick}
          bottomFlat
        />
        <div className="mt-[4px] mb-[32px] rounded-b-[5px]">
          {lessonMode == 0 ? (
            <DSRadio controlSelected={[lessonOption, handleOnclick]} containerClassName="flex flex-col space-y-[8px]">
              {lessonRadioGroup1({ t }).radioGroup.items.map((radioItem, idx) => {
                return (
                  <DSRadio.Item key={`radio-group1-${idx}`} value={radioItem.value}>
                    {radioItem.name}
                  </DSRadio.Item>
                )
              })}
            </DSRadio>
          ) : (
            <DSRadio controlSelected={[lessonOption, handleOnclick]} containerClassName="flex flex-col space-y-[8px]">
              {lessonRadioGroup2({ t }).radioGroup.items.map((radioItem, idx) => {
                return (
                  <DSRadio.Item key={`radio-group2-${idx}`} value={radioItem.value}>
                    {radioItem.name}
                  </DSRadio.Item>
                )
              })}
            </DSRadio>
          )}
        </div>
      </div>
    )
  }

  const isAdminLogin = useIsAdminLogin()
  type SubmitButtonPropsType = {
    lessonId: any
    item: any
    introRef: any
  }

  const SubmitButton = ({ lessonId, item, introRef }: SubmitButtonPropsType) => {
    const [loading, setLoading] = useState(false)
    const { t } = useTranslation()
    const router = useRouter()
    const convertList = (list) => {
      return list.map((item, i) => {
        return {
          id: item.id,
          value: item.selected,
        }
      })
    }

    //수업입장, 수업페이지로 이동
    const enter = async () => {
      const id = lessonId
      setLoading(true)

      isAdminLogin ||
        track({
          location: LOCATION.LESSON,
          log_type: LOG_TYPE.LESSON.ENTER,
          log_category: LOG_CATEGORY.SPEAK,
          lesson_id: lessonId,
          duration: item.lesson?.duration,
        })
      const response = await axiosGet(apis.lessons.enter(id))
      if (response.success) {
        setLoading(false)
        locationMove(router, locale, urls.student.portal.lessons.classroom.as(id))
      } else {
        if (response.message) {
          basicPopup.close('lessonStylePopup')
          confirmPopup.show({
            id: 'alert-enter',
            title: t(s_upcoming_lessons.lesson_enter_modal_title),
            body: <div className="text-[14px] font-normal text-purple-500">{response.message}</div>,
            leftBtn: false,
          })
        } else {
          alert('Error occurred, page will be refreshed.')
          window.location.reload()
        }
      }
      setLoading(false)
    }

    const handleSetting = async (e) => {
      const url = `${apis.lessons.setting(lessonId)}`
      if (handleSubmitLessonStyleWebview) {
        handleSubmitLessonStyleWebview(
          item,
          lessonId,
          skipIntro,
          intro,
          allowRecord,
          allowCAF,
          lessonMode,
          lessonOption,
          otherRequest,
          intensiveArea,
          selectedRequest,
          convertList
        )
        return
      }
      setLoading(true)
      const response = await axiosPost(url, {
        lesson_id: lessonId,
        skip_intro: skipIntro,
        introduction: skipIntro ? intro : item.intro.desc,
        allow_record: allowRecord,
        allow_caf: allowCAF,
        class_type: lessonMode,
        correcting_style: lessonOption,
        other_request: otherRequest,
        ringle_area: convertList(intensiveArea),
        selected_requests: convertList(selectedRequest),
      })
      setLoading(false)

      if (response.success) {
        if (isConfirmModalOpen) {
          enter()
        } else {
          basicPopup.close('lessonStylePopup')
          setShowPopup(false)
          toastSuccess(t(n_upcoming_lessons.lesson_style.toast))
        }
      } else {
        alert('Something Wrong')
      }
      e.stopPropagation()
    }

    const handleCancel = (e) => {
      if (handleCancelLessonStyleWebview) {
        handleCancelLessonStyleWebview(e)
      } else {
        setShowPopup(false)
        basicPopup.close('lessonStylePopup')
      }
    }
    return (
      <div className="mb-[34px] flex w-full justify-center sm:mb-0 sm:justify-start">
        <div></div>
        <div className="flex w-full space-x-[8px] sm:ml-auto sm:w-fit">
          {!isWebview ? (
            <>
              <div>
                <DSButton type={BUTTON_TYPE.OUTLINE} size={BUTTON_SIZE.MD} onClick={handleCancel}>
                  {loading ? <LoadingSpinner show sm /> : t(n_common.btn_cancel)}
                </DSButton>
              </div>
              <div>
                <DSButton
                  type={BUTTON_TYPE.SOLID}
                  size={BUTTON_SIZE.MD}
                  disabled={disabled}
                  className="text-white"
                  onClick={handleSetting}
                >
                  {loading ? (
                    <LoadingSpinner show sm />
                  ) : isConfirmModalOpen ? (
                    t(s_common.save_and_enter)
                  ) : (
                    t(n_common.btn_save)
                  )}
                </DSButton>
              </div>
            </>
          ) : (
            <>
              <DSButton type={BUTTON_TYPE.OUTLINE} size={BUTTON_SIZE.MD} onClick={handleCancel}>
                {loading ? <LoadingSpinner show sm /> : t(n_common.btn_cancel)}
              </DSButton>

              <DSButton
                type={BUTTON_TYPE.SOLID}
                size={BUTTON_SIZE.MD}
                disabled={disabled}
                className="text-white"
                onClick={handleSetting}
              >
                {loading ? (
                  <LoadingSpinner show sm />
                ) : isConfirmModalOpen ? (
                  t(s_common.save_and_enter)
                ) : (
                  t(n_common.btn_save)
                )}
              </DSButton>
            </>
          )}
        </div>
      </div>
    )
  }

  useEffect(() => {
    if (!router) return
    sendPageViewEvent({ page_name: 'lesson_style' })
  }, [router.asPath])

  return (
    <>
      {item.lesson && (
        <div className="mx-[16px] flex flex-col sm:mx-0">
          <RecordChoose item={item} />
          <CAFChoose />
          <IntroChoose
            setDisabled={setDisabled}
            skipIntro={skipIntro}
            setSkipIntro={setSkipIntro}
            intro={intro}
            setIntro={setIntro}
          />
          <OptionChoose item={item} />
          <div className="mb-[32px]">
            <div>
              <div className="mb-[16px] text-[16px] font-medium">
                {t(n_upcoming_lessons.lesson_style.intensive_focus_title)}
              </div>
              <IntensiveChoose
                item={item}
                setDisabled={setDisabled}
                setIntensiveArea={setIntensiveArea}
                intensiveArea={intensiveArea}
              />
            </div>
          </div>
          <div>
            <div className="mb-[16px] text-[16px] font-medium">
              {t(n_upcoming_lessons.lesson_style.additional_request_title)}
            </div>
            <RequestChoose
              item={item}
              setDisabled={setDisabled}
              selectedRequest={selectedRequest}
              setSelectRequest={setSelectRequest}
            />
          </div>
          <div>
            <div className="mb-[8px] text-[16px] font-medium">
              {t(n_upcoming_lessons.lesson_style.other_request_title)}
            </div>

            <AdditionalInput setDisabled={setDisabled} otherRequest={otherRequest} setOtherRequest={setOtherRequest} />
          </div>
          <div className="h-[70px]"></div>
          <div
            className={classNames(
              isWebview ? 'sticky bottom-0 w-full bg-white pt-[12px]' : 'sticky bottom-0 w-full bg-white pt-[12px]'
            )}
          >
            <SubmitButton lessonId={lessonId} item={item} introRef={introRef} />
          </div>
        </div>
      )}
    </>
  )
}
export default LessonStylePopupBody

type IntensiveChoosePropsType = {
  item: any
  setDisabled?: any
  setIntensiveArea?: any
  intensiveArea: any
  readOnly?: boolean
}

export const IntensiveChoose = ({
  item,
  setDisabled,
  setIntensiveArea,
  intensiveArea,
  readOnly,
}: IntensiveChoosePropsType) => {
  const setIntensive = (e, id) => {
    setDisabled(false)
    const cloneIntensive = [...intensiveArea]
    setIntensiveArea(
      cloneIntensive.map((item) => {
        if (item.id == id) {
          return {
            ...item,
            selected: !item.selected,
          }
        }
        return item
      })
    )
  }

  return (
    <div className="flex flex-col space-y-[8px]">
      {item.intensive_area.map((v, i) => (
        <div key={i} onClick={readOnly ? null : (e) => setIntensive(e, v.id)} className="mr-[16px] flex flex-row">
          <CheckBoxs
            disabled={readOnly}
            checked={intensiveArea[i]?.selected}
            label={
              <label htmlFor={`intensive-${v.id}`}>
                <div className="mr-[45px] text-[14px] font-normal text-black">{v.title}</div>
              </label>
            }
          />
        </div>
      ))}
    </div>
  )
}

type RequestChoosePropsType = {
  setDisabled?: any
  item: any
  selectedRequest: any
  setSelectRequest?: any
  readOnly?: boolean
}

export const RequestChoose = ({
  setDisabled,
  item,
  selectedRequest,
  setSelectRequest,
  readOnly,
}: RequestChoosePropsType) => {
  const { isLocaleKO } = useTranslation()
  const setRequest = (e, id) => {
    setDisabled(false)
    const cloneRequests = [...selectedRequest]
    setSelectRequest(
      cloneRequests.map((item) => {
        if (item.id == id) {
          return {
            ...item,
            selected: !item.selected,
          }
        }
        return item
      })
    )
  }
  return (
    <div className="mb-[32px]">
      {item.selectable_requests.map((item, i) => (
        <div key={i} onClick={readOnly ? null : (e) => setRequest(e, item.id)} className="mr-[16px]">
          <CheckBoxs
            disabled={readOnly}
            checked={selectedRequest[i].selected}
            label={
              <label className="custom-control-label display-9" htmlFor={`selectable-${item.id}`}>
                <div className="my-[4px] text-[14px] font-normal text-black">
                  {isLocaleKO ? item.contentKor : item.content}
                </div>
              </label>
            }
          />
        </div>
      ))}
    </div>
  )
}

type AdditionalInputPropsType = {
  otherTextRef?: any
  setDisabled?: any
  otherRequest: any
  setOtherRequest: any
  readOnly?: boolean
}

export const AdditionalInput = ({
  otherTextRef,
  setDisabled,
  otherRequest,
  setOtherRequest,
  readOnly,
}: AdditionalInputPropsType) => {
  const { t } = useTranslation()
  return (
    <CardTextarea
      style={{
        fontSize: '14px',
        resize: 'none',
        borderRadius: 4,
      }}
      rows={5}
      className="rounded-5 mt-4 border-gray-300"
      onChange={(e) => {
        setOtherRequest(e.target.value)
        if (!readOnly) setDisabled(false)
      }}
      value={otherRequest}
      placeholder={t(s_lesson_style.additional_request.placeholder)}
      disabled={readOnly}
    />
  )
}

const IntroChoose = ({ setDisabled, skipIntro, setSkipIntro, intro, setIntro }) => {
  const { t } = useTranslation()
  const { currentUser } = useCurrentUser()
  const handleOnclick = (tf) => {
    setDisabled(false)
    setSkipIntro(tf)
  }

  return (
    <div className="mb-[32px]">
      <div className="mb-[8px] text-[16px] font-medium">{t(n_upcoming_lessons.lesson_style.intro_title)}</div>
      <ButtonToggleTab
        defaultChecked={skipIntro}
        leftLabel={t(n_upcoming_lessons.lesson_style.intro_no)}
        rightLabel={t(n_upcoming_lessons.lesson_style.intro_yes)}
        handleClick={handleOnclick}
      />
      {skipIntro && (
        <div className="flex flex-col break-normal">
          <CardTextarea
            rows={5}
            value={intro}
            placeholder={t(n_upcoming_lessons.lesson_style.intro_placeholder)}
            onChange={(e) => {
              setIntro(e.target.value)
              setDisabled(false)
            }}
            className="mt-4 p-16"
          />
        </div>
      )}
    </div>
  )
}
